import { useEffect, useState } from "react";
import { LayoutPages } from "../layoutPages";
import { MY_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { FEATURES, hasFeature } from "../../entities/my";
import { TutorPaymentDetails } from "../../widgets/tutorPaymentDetails";
import { Logout } from "../../features/logout";
import classes from './my.module.scss'
import { AccessDeniedRedirect } from "../../shared/ui/accessDeniedRedirect";
import { HOME_ROUTE } from "../../app/router/routes";
import { FEATURE_SECTIONS } from "../../entities/my";
import { IWorkTg, workTgService } from "../../entities/workTg";
import { LoaderSpinner } from "../../shared/ui/spinner";
import { userService } from "../../entities/user";

const ROLE_TITLES: Record<string, string> = {
    tutor: 'Исполнитель',
    admin: 'Администратор',
    super_admin: 'Супер-администратор',
    assistant: 'Главрук',
}

export default function MyPage() {

    const {my} = useAppSelector(s => s.myReducer)
    const [workTgs, setWorkTgs] = useState<IWorkTg[]>([])
    const [isWorkTgsLoading, setIsWorkTgsLoading] = useState(false)
    const showTutorPaymentDetails = hasFeature(my, FEATURES.PROFILE.PAYMENT_DETAILS_READ, my.id)
    const canUpdatePaymentDetails = hasFeature(my, FEATURES.PROFILE.PAYMENT_DETAILS_UPDATE, my.id)
    const canViewWorkTgs = hasFeature(my, FEATURES.WORK_TGS.LIST)
    const shouldShowWorkTgs = my.role === 'tutor' || canViewWorkTgs
    const profileName = my.full_name.trim() || 'Пользователь'
    const profileLetter = profileName.charAt(0).toUpperCase()
    const roleTitle = my.role === 'tutor' ? 'Исполнитель' : my.role_name || ROLE_TITLES[my.role] || my.role

    useEffect(() => {
        if(!shouldShowWorkTgs){
            setWorkTgs([])
            return
        }

        let isActual = true

        const loadWorkTgs = async () => {
            try{
                setIsWorkTgsLoading(true)
                const items = my.role === 'tutor'
                    ? (await userService.getPersonalData(my.id)).work_tgs
                    : await workTgService.getAll()
                if(isActual){
                    setWorkTgs(items)
                }
            }
            catch{
                if(isActual){
                    setWorkTgs([])
                }
            }
            finally{
                if(isActual){
                    setIsWorkTgsLoading(false)
                }
            }
        }

        loadWorkTgs()

        return () => {
            isActual = false
        }
    }, [canViewWorkTgs, my.id, my.role, shouldShowWorkTgs])

    if(!hasFeature(my, FEATURE_SECTIONS.PROFILE)){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    return (
        <LayoutPages title={MY_ROUTE.name}>
            <section className={classes.container}>
                <section className={classes.card}>
                    <section className={classes.profile}>
                        <section className={classes.avatar}>{profileLetter}</section>
                        <section className={classes.profileInfo}>
                            <section className={classes.name}>{profileName}</section>
                        </section>
                    </section>
                </section>

                <section className={classes.card}>
                    <section className={classes.title}>Информация о профиле</section>
                    <section className={classes.infoGrid}>
                        <section className={classes.infoItem}>
                            <section className={classes.infoLabel}>ФИО</section>
                            <section className={classes.infoValue}>{profileName}</section>
                        </section>
                        <section className={classes.infoItem}>
                            <section className={classes.infoLabel}>Роль</section>
                            <section className={classes.infoValue}>{roleTitle}</section>
                        </section>
                        {shouldShowWorkTgs && (
                            <section className={`${classes.infoItem} ${classes.infoItemWide}`}>
                                <section className={classes.infoLabel}>Доступные ТГ</section>
                                {isWorkTgsLoading ? (
                                    <section className={classes.loaderWrap}>
                                        <LoaderSpinner />
                                    </section>
                                ) : workTgs.length > 0 ? (
                                    <section className={classes.infoTags}>
                                        {workTgs.map(workTg => (
                                            <section key={workTg.id} className={classes.infoTag}>
                                                {workTg.name}
                                            </section>
                                        ))}
                                    </section>
                                ) : (
                                    <section className={classes.infoValueMuted}>Доступные ТГ не найдены</section>
                                )}
                            </section>
                        )}
                    </section>
                </section>

                {
                    showTutorPaymentDetails &&
                    <section className={classes.card}>
                        <section className={classes.title}>Платежные реквизиты</section>
                        <TutorPaymentDetails userId={my.id} canEdit={canUpdatePaymentDetails} />
                    </section>
                }

                <section className={classes.logout}>
                    <Logout />
                </section>
            </section>
        </LayoutPages>
    )
}
